var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import SubscribeToNewsletter from "./SubscribeToNewsletter";
import Icon from "../../../components/Library/Icon/Icon";
import { updateUnAuthedSubscriptions, updateUserSubscriptions } from "../../../actions/user";
import { getLocalItem, setLocalItem } from "../../../utils/localdb";

import styles from "./AuthorSubscribe.css";

var AuthorSubscribe = function (_Component) {
  _inherits(AuthorSubscribe, _Component);

  function AuthorSubscribe(props) {
    _classCallCheck(this, AuthorSubscribe);

    var _this = _possibleConstructorReturn(this, (AuthorSubscribe.__proto__ || Object.getPrototypeOf(AuthorSubscribe)).call(this, props));

    _this.onSubscribed = function (email, subscription) {
      if (_this.props.isLoggedIn) {
        _this.props.updateUserSubscriptions(_this.props.user.subscriptions, subscription);
      } else {
        _this.props.updateUnAuthedSubscriptions(email, [subscription.id]).then(function () {
          setLocalItem("AxiosSubscriptions", [].concat(_toConsumableArray(getLocalItem("AxiosSubscriptions") || []), [_this.props.subscription.id]), { expires: 30 });
        });
      }
      _this.setState({
        subscribing: false,
        thanks: !_this.props.isLoggedIn,
        alreadySubscribedTo: [].concat(_toConsumableArray(_this.state.alreadySubscribedTo), [subscription.id])
      });
    };

    _this.onSubscribing = function () {
      _this.setState({ subscribing: true });
    };

    _this.onClose = function () {
      _this.setState({ subscribing: false, thanks: false });
    };

    _this.onLeft = function () {
      var length = _this.props.author.primary_contributor_for.length;
      _this.setState({ index: (length + _this.state.index - 1) % length });
    };

    _this.onRight = function () {
      var length = _this.props.author.primary_contributor_for.length;
      _this.setState({ index: (_this.state.index + 1) % length });
    };

    _this.state = {
      alreadySubscribedTo: [],
      subscriptions: null,
      subscribing: false,
      thanks: false,
      index: 0
    };
    return _this;
  }

  _createClass(AuthorSubscribe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.isLoggedIn) {
        var alreadySubscribedTo = getLocalItem("AxiosSubscriptions");
        this.setState({ alreadySubscribedTo: alreadySubscribedTo || [] });
      } else if (this.props.user) {
        this.setState({ alreadySubscribedTo: this.props.user.subscriptions.map(function (s) {
            return s.id;
          }) });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.isLoggedIn && !this.props.user && nextProps.user) {
        this.setState({ alreadySubscribedTo: nextProps.user.subscriptions.map(function (s) {
            return s.id;
          }) });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var author = this.props.author;

      if (!author || !author.primary_contributor_for || author.primary_contributor_for.length === 0) return null;

      var subscriptions = author.primary_contributor_for.map(function (subscription) {
        return _extends({}, subscription, {
          isSubscribed: _this2.state.alreadySubscribedTo.includes(subscription.id)
        });
      });

      var subscription = subscriptions[this.state.index];

      return React.createElement(
        "div",
        { className: styles.root },
        React.createElement(
          "div",
          { className: styles.featured },
          author.display_name + "'s Newsletters"
        ),
        this.state.subscribing || this.state.thanks ? React.createElement(Icon, {
          className: styles.close,
          name: "close",
          description: "Cancel attempting to subscribe to author's newsletter",
          onClick: this.onClose }) : React.createElement(
          "div",
          null,
          React.createElement(Icon, {
            className: styles.left,
            name: "caret/left",
            description: "Move left through author's newsletters",
            onClick: this.onLeft }),
          React.createElement(Icon, {
            className: styles.right,
            name: "caret/right",
            description: "Move right through author's newsletters",
            onClick: this.onRight })
        ),
        React.createElement(SubscribeToNewsletter, {
          subscription: subscription,
          subscribing: this.state.subscribing,
          thanks: this.state.thanks,
          onSubscribed: this.onSubscribed,
          onSubscribing: this.onSubscribing })
      );
    }
  }]);

  return AuthorSubscribe;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.data,
    isLoggedIn: !!state.authDrawer.authToken // TODO: implement this when user stuff is done
  };
};

AuthorSubscribe.propTypes = {
  user: PropTypes.object,
  author: PropTypes.object,
  isLoggedIn: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, { updateUnAuthedSubscriptions: updateUnAuthedSubscriptions, updateUserSubscriptions: updateUserSubscriptions })(AuthorSubscribe);


// WEBPACK FOOTER //
// ./src/author/components/AuthorSubscribe/AuthorSubscribe.js